//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useRef, useState} from 'react';

import { useTheme } from '@mui/material/styles';
import {
  TextField,
} from '@mui/material';

// === UTILS ===
import {Spacer} from 'components/Spacer';
import Styled from 'components/Styled/Styled';

// === API ===
import {sendMessageData} from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function CommentEdit(props) {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const { file_id, comment_id, comment, handleClose } = props;
  
  const theme = useTheme();
  const ref   = useRef();
  
  const [ text, setText ] = useState(comment);

  //#endregion

  //#region [STYLES]

  // === STYLE ===
  const _styles = {
    container: { 
      position : 'relative',

      width   : '100%',

      justifyContent : 'center',
      alignText      : 'center',
      padding: '10px',

      background : theme.palette.background.primary[theme.palette.mode],
    },
    user_select: {
      width: '100%',
      marginRight: '1rem',
    },
    comment: {
      width  : 'calc( 100% - 8px )',
      height : '100%',
    },
    control_box: {
      padding: '1rem',
      paddingBottom: 0,
    },
  };

  // === ATTRIBUTES ===
  const COMMENT = {
      sx        : _styles.comment,
      inputRef  : ref,
      id        : 'field-comment',
      variant   : 'filled',
      multiline : true,
      minRows   : 3,
      defaultValue : props.value,
    }

  const CONTROL_BOX = {
    sx: _styles.control_box,
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onChange_Text( event ) {
    //-----------------------------------------------------------------
    try {
      setText( event.target.value );
    } catch (error) {
      console.warn( error );
    }
  }

  //-----------------------------------------------------------------
  function onClick_Save() {
    //-----------------------------------------------------------------
    try {
      if( text === '' ) return;
      setText( '' );
      sendMessageData( 'FILE_COMMENT_UPDATE', {file_id, comment_id, text } );

      handleClose();
    } catch (error) {
      console.warn( error );
    }
  }

  //-----------------------------------------------------------------
  function onClick_Cancel() {
    //-----------------------------------------------------------------
    try {
      handleClose();
    } catch (error) {
      console.warn( error );
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div style={_styles.container}>
        <TextField value={text} { ...COMMENT } onChange={onChange_Text} />
        <Styled styles={[{height: '10px'}]} />
        <Styled styles={[{display:'flex'}]}>
          <button style={{border: '0px',borderRadius: '5px', height: '30px', width: '50px'}} onClick={onClick_Save}>Save</button>
          <Spacer />
          <button style={{border: '0px',borderRadius: '5px', height: '30px', width: '50px'}} onClick={onClick_Cancel}>Cancel</button>
        </Styled>
      </div>
    );
  }

  //#endregion

  return display();
}